let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableData = {
    regcustomerTable:{
        loading:false,
        isFullscreen:false,
        selection: 'multiple',
        showSelection:true,
        selected: [],
        data: [],
        count: 0,
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 0, page: 1, search:'' },
        tools: {
            show_toolbar: true,
            btns: [
                { index: 0, name: ['新增'], icon: 'fas fa-plus', check_lines: 0, on_click: [], sign: 'add', },
                { index: 1, name: ['删除'], icon: 'fas fa-trash', check_lines: 0, on_click: [], sign: 'delete', },
                { index: 3, name: ['导入'], icon: 'fas fa-file-import', check_lines: 0, on_click: [], sign: 'import', },
                { index: 2, name: ['导出'], icon: 'fas fa-file-export', check_lines: 0, on_click: [], sign: 'export', },
            ]
        },
        columns: [
            {name: 'id', align: 'left', label: 'id', field: 'id', sortable: true},
            {name: 'DPID', align: 'left', label: '分销商ID', field: 'DPID', sortable: true},
            {name: 'DPName', align: 'left', label: '分销商名称', field: 'DPName', sortable: true},
            {name: 'RegCustomer', align: 'left', label: '注册客户名称', field: 'RegCustomer', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'USCI', align: 'left', label: '注册客户税号', field: 'USCI', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'RegDate', align: 'left', label: '注册客户确认日期', field: 'RegDate', sortable: true},
        ]
    }
};
const dialogData = {
    dialogFormData: {
        dialog_class: 'defalut',
        btns: true,
        items: [
          {
                index: 0, label: '注册客户名称', placeholder: '请输入注册客户名称', showlabel: true, name: 'RegCustomer', value: '', type: 'input', filled: false, outlined: true, disable: false,
                required: true,
                rules: [
                    val => (val && val.length > 0) || '请输入注册客户名称'
                ],
                variant: {
                    origin: ['e2e', 'getFormData', 'update_base_data'], auto_assignment: true,
                }
            },{
                index: 0, label: '注册客户税号', placeholder: '请输入注册客户税号', showlabel: true, name: 'USCI', value: '', type: 'input', filled: false, outlined: true, disable: false,
                required: true,
                rules: [
                    val => (val && val.length > 0) || '请输入注册客户税号'
                ],
                variant: {
                    origin: ['e2e', 'getFormData', 'update_base_data'], auto_assignment: true,
                }
            },{
                index: 0, label: '确认日期', placeholder: '请选择确认日期', showlabel: true, name: 'RegDate', value: '', type: 'date', filled: false, outlined: true, disable: false,
                variant: {
                    origin: ['e2e', 'getFormData', 'update_base_data'], auto_assignment: true,
                }
            }
        ],
    },
    exportDialogData: {
        loading: false,
        dialog_class: 'default',
        btns: true,
        items: [
            {
                index: 2, label: '格式', showlabel: true, name: 'mode', value: '', type: 'select', filled: false, outlined: true, disable: false,
                rules: [''],
                options: ['XLSX', 'CSV'],
                variant: {
                    origin: ['e2e', 'getFormData', 'update_base_data'], auto_assignment: true,
                },
                minWidth: 160
            },
            {
                index: 2, label: '数据集', showlabel: true, name: 'record', value: '', type: 'select', filled: false, outlined: true, disable: false,
                options: ['全部数据', '搜索结果'],
                rules: [''],
                variant: {
                    origin: ['e2e', 'getFormData', 'update_base_data'], auto_assignment: true,
                },
                minWidth: 160
            },
        ]
    },
}
const state = () => ({
    regcustomer: Object.assign({}, tableData,dialogData),
})
const getters = {
    getRegcustomerPost: state => state.regcustomer.regcustomerTable,
    getRegcustomerDialog : state => state.regcustomer.dialogFormData,
    getExportDialog: state => state.regcustomer.exportDialogData,
}
const mutations ={
    clearExportDialog(state) {
        state.regcustomer.exportDialogData.items = state.regcustomer.exportDialogData.items.map(item => {
            return {
                ...item,
                value: ''
            }
        })
    },
    setList(state, data) {
        state.regcustomer.regcustomerTable.pagination.rowsNumber = data.count
        state.regcustomer.regcustomerTable.data = data.data
    },
    ['refreshTableHeight'](state, data) {
        state.regcustomer.regcustomerTable.maxHeight = (data+50) + 'px';
    },
    ['clearData'](state, data) {
        state.regcustomer.regcustomerTable.pagination.page = 1
        state.regcustomer.regcustomerTable.data = []
    },
    ['clearSelected'](state, data) {
        state.regcustomer.regcustomerTable.selected = []
    },
    ['setSearch'](state, data) {
        state.regcustomer.regcustomerTable.pagination.search = data
    },
    ['clearDialog'](state) {
        state.regcustomer.dialogFormData.items = state.regcustomer.dialogFormData.items.map(item => {
            return {
                ...item,
                value: ''
            }
        })
    },
}
const actions = {
    async ['regcustomerExport']({ state, dispatch, rootState }, payload) {
        const params = state.regcustomer.exportDialogData.items.map(item => {
            return {
                [item.name]: item.value
            }
        })
        let obj = {}
        if (state.regcustomer.regcustomerTable.pagination.search && state.regcustomer.regcustomerTable.pagination.search!='') {//设置搜索条件，客户名称和客户税号
            obj.multi_query = {}
            obj.multi_query.keys = state.regcustomer.regcustomerTable.pagination.search.trim();
            obj.multi_query.fields = ['RegCustomer','USCI'];
        } else {
            obj = {key:''};
        }
        obj.file_type = params[0].mode ? params[0].mode.toLowerCase() : 'xlsx';
        obj.search_all = params[1].record ? params[1].record == '全部数据' ? true : false : true;
        let msg = { command: "regcustomer__export", message: obj, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async ['return_regcustomer__export']({ state, commit, dispatch }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
        state.regcustomer.exportDialogData.loading = false
    },
    async ['return_regcustomer__import']({ state, commit, dispatch }, payload) {
        state.regcustomer.regcustomerTable.loading = false
        if (payload.success) {
            commit('clearData');
            dispatch('fetch-list');
            dispatch('response/success-tip', { message: '导入成功' }, { root: true })
        }
    },
    async ['onSearch']({ dispatch, state,commit }, payload) {
        commit('clearData');
        commit('setSearch',payload)
        dispatch('fetch-list')
    },
    async ['fetch-list']({ state, dispatch, commit }, payload) {
        if (state.regcustomer.regcustomerTable.loading == true) return
        let params = {}
        if (state.regcustomer.regcustomerTable.pagination.search && state.regcustomer.regcustomerTable.pagination.search!='') {//设置搜索条件，客户名称和客户税号
            params.multi_query = {}
            params.multi_query.keys = state.regcustomer.regcustomerTable.pagination.search.trim();
            params.multi_query.fields = ['RegCustomer','USCI'];
        } else {
            params = {key:''};
        }
        commit('clearSelected');
        params.pagination = state.regcustomer.regcustomerTable.pagination;
        let msg = { command: "regcustomer__list", message: params, to: "client" }

        dispatch('channel/socket_send', msg, { root: true })
        state.regcustomer.regcustomerTable.loading = true
    },
    async ['return_regcustomer__list']({ state, commit }, payload) {
        state.regcustomer.regcustomerTable.loading = false;
        if (payload.success) {
            commit('setList', payload.data)
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        state.regcustomer.regcustomerTable.loading = true
        let msg = { command: "regcustomer__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['export_import']({ state, dispatch, rootState }, payload) {
        state.regcustomer.regcustomerTable.loading = true
        let msg = { command: "regcustomer__import", message: {file:payload.result}, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导入' }, { root: true })
    },
    async ['addRegcustomer']({ state, commit, dispatch }) {
        let params = {}
        state.regcustomer.dialogFormData.items.map(item => {
            params[item.name] = item.value
        });
        let msg = { command: "regcustomer__add", message:{data:params}, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_regcustomer__add']({ state, dispatch }, payload) {
        console.log(payload,'新增成功');
        if(payload.success){
            dispatch('response/success-tip', { message: '新增成功' }, { root: true })
            dispatch('fetch-list');
        }
    },
    async ['deleteData']({ state, dispatch }) {
        const ids = state.regcustomer.regcustomerTable.selected.map(item => item.id)
        let message = {ids}
        let msg = { command: "regcustomer__delete", message , to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_regcustomer__delete']({ state, dispatch }, payload) {
        console.log('删除成功');
        if(payload.success){
            dispatch('response/success-tip', { message: '删除成功' }, { root: true })
            dispatch('fetch-list');
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
